<template>
  <div class="declaracao-de-privacidade">
    <h2>She'sTech Conference 2021</h2>
    <h3>Declaração de Privacidade</h3>

    <p>Olá! Seja muito bem-vinda à She’s Tech Conference 2021 (Edição Digital)</p>

    <p>
      Considerando seu direito à proteção de dados pessoais e imagem, temos alguns
      avisos importantes que precisamos que você leia e considere para poder se
      inscrever em nosso evento:
    </p>

    <p>
      1) Sobre seus dados:   1.a) Quais dados colhemos: Dados pessoais:
      (i) nome; (ii) e-mail; (iii) sexo; (iv) idade e (v) dados sobre seus
      interesses e área de atuação; Dados pessoais sensíveis: (vi) raça/etnia.
      Esses são dados são passíveis de proteção de acordo com a Lei Geral de
      Proteção de Dados (Lei no 13.709/18).
    </p>

    <p>1.b) Quando colhemos seus dados: no momento da sua inscrição.</p>

    <p>
      1.c) Para que utilizamos seus dados: colhemos esses dados para
      (i) processar a sua inscrição e te conceder acesso à plataforma
      para que você possa participar do evento; (ii) enviar e-mails e
      comunicações para você relacionadas ao evento; (iii) enviar e-mails e
      comunicações para você sobre a She’s Tech, suas ações, parceiros e patrocinadores.
    </p>

    <p>
      1.d) A base legal para tratamento dos seus dados é (i) dados pessoais:
      art. 7º, V da Lei no 13.709/18. Esclarecemos que a She’s Tech não compartilha
      seus dados com parceiros e patrocinadores. Caso você não deseje receber comunicações
      por e-mail da She’s Tech, poderá se descadastrar acessando a opção “não desejo
      mais receber esses e-mails” ao final de nossas comunicações; (ii) dados pessoais
      sensíveis: art. 7º, I da Lei no 13.709/18: são utilizados de forma anonimizada,
      para podermos medir o impacto e alcance de nossas iniciativas.
    </p>

    <p>
      2) Sua imagem: nosso evento será realizado através de plataforma digital com
      compartilhamento de dados, som e imagem por parte de palestrantes e participantes.
      Nossas palestras e workshops serão gravados e poderão ser compartilhados, de forma
      integral ou parcial, em plataformas de acesso público (como YouTube e redes sociais),
      sem distinção entre as pessoas que participarem. Assim, colhemos a autorização das
      pessoas que desejam participar de nosso evento para captação e reprodução de suas
      imagens, dados e voz, de forma gratuita e por prazo indeterminado, pela She’s Tech
      e eventualmente por parte de seus parceiros e patrocinadores, seja por meio de sites,
      plataformas de acesso público, redes sociais, materiais impressos (como cartazes,
      folders, panfletos, livros, catálogos, revistas e jornais, digitais ou físicos),
      programas e chamadas em emissoras de rádio e televisão ou qualquer outro meio de
      comunicação existente, no Brasil ou no exterior.
    </p>

    <p>
      Diante do exposto, estou ciente da colheita e tratamento de meus dados pessoais
      para as finalidades aqui descritas.
    </p>

    <p>Autorizo o uso de minha imagem para as finalidades aqui descritas.</p>
  </div>
</template>

<script>
export default {
  name: 'DeclaracaoDePrivacidade',
};
</script>

<style lang="scss" scoped>
.declaracao-de-privacidade {
  padding: 1rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;

  h3 {
    margin-bottom: 1rem;
  }

  p {
    margin-bottom: 1rem;
  }
}
</style>
